@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;

.itemCardWithBorder {
    border: rem(1px) solid $itemCardBorderColor;
    border-radius: rem(8px);
    gap: rem(12px);
    padding: rem(18px) rem(20px);

    &.itemCardWithBorder {
        align-items: flex-start;
    }
}
